module.exports = __webpack_public_path__ + "img/weixin_logo.fda7dc7b.png";